'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var REQUEST = exports.REQUEST = 'REQUEST';
var SUCCESS = exports.SUCCESS = 'SUCCESS';
var FAILURE = exports.FAILURE = 'FAILURE';

exports.default = function (base) {
    var types = { BASE: base };

    /* Smart way but not IDLE friendly
    [REQUEST, SUCCESS, FAILURE].forEach(type => {
    types[type] = `${base}_${type}`;
    });
    */

    types.REQUEST = base + '_REQUEST';
    types.SUCCESS = base + '_SUCCESS';
    types.FAILURE = base + '_FAILURE';

    return types;
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/utils/createFetchTypes.js
// module id = 153
// module chunks = 0